/**
 * Pure helpers for `Drivers.tsx`, kept dependency-free (no React/MUI/store
 * imports) so they can be unit tested directly in this repo's Node-only vitest
 * environment without needing a DOM.
 */

/**
 * `handleSubmit` (register driver), `handleUnassignTruck`, and
 * `handleAssignSubmit` in `Drivers.tsx` each call a driver-related endpoint
 * and interpret the response the same way: a loosely-typed payload shaped
 * like `{ success?: boolean; result?: unknown }`, treated as successful when
 * either field is truthy. Before this was centralized, each call site
 * checked `data.success || data.result` inline with no `else` branch, so a
 * response the backend rejected without throwing (e.g. `{ success: false }`)
 * silently showed nothing instead of an error toast.
 *
 * Centralizing the check here means all three call sites agree on what
 * counts as success, and — unlike the inline version — it's unit-testable
 * without rendering the page.
 */
export function isSuccessfulDriverActionResponse(response: unknown): boolean {
  if (!response || typeof response !== 'object') return false;
  const data = response as { success?: boolean; result?: unknown };
  return Boolean(data.success || data.result);
}
